export default [
  {
    path: '/demo',
    name: 'Demo',
    component: () =>
      import(/* webpackChunkName:'demo' */
        '@/views/common/ViewChild.vue'),
    meta: {
      anonymous: true,
    },
    redirect: '/demo/control',
    children: [
      {
        path: 'control',
        name: 'DemoControl',
        component: () =>
          import(/* webpackChunkName:'demo-control' */
            '@/views/demo/DemoControl.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'tree',
        name: 'DemoTree',
        component: () =>
          import(/* webpackChunkName:'demo-tree' */
            '@/views/demo/DemoTree.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'combobox',
        name: 'DemoCombobox',
        component: () =>
          import(/* webpackChunkName:'demo-combobox' */
            '@/views/demo/DemoCombobox.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'form',
        name: 'DemoForm',
        component: () =>
          import(/* webpackChunkName:'demo-form' */
            '@/views/demo/DemoForm.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'message',
        name: 'DemoMessage',
        component: () =>
          import(/* webpackChunkName:'demo-message' */
            '@/views/demo/DemoMessage.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'toast',
        name: 'DemoToast',
        component: () =>
          import(/* webpackChunkName:'demo-toast' */
            '@/views/demo/DemoToast.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'super',
        name: 'DemoSuper',
        component: () =>
          import(/* webpackChunkName:'demo-super' */
            '@/views/demo/DemoSuper.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'grid-edit',
        name: 'DemoGridEdit',
        component: () =>
          import(/* webpackChunkName:'demo-grid-edit' */
            '@/views/demo/DemoGridEdit.vue'),
        meta: {
          anonymous: true,
        },
      },
      {
        path: 'editor',
        name: 'DemoEditor',
        component: () =>
          import(/* webpackChunkName:'demo-editor' */
            '@/views/demo/DemoEditor.vue'),
        meta: {
          anonymous: true,
          title: 'Dashboard',
          // excludeHeader: true,
        },
      },
    ],
  },
]
